import EA from 'helpers/init';

export default EA.Methods.bannerAdd = ($this, payload) => {
    var $this = $($this);
    var creative_name = $this.attr('creative-name');
    var creative_slot = $this.attr('creative-slot');
    var promotion_name = $this.attr('promotion-name');
    var promotion_id = $this.attr('promotion-id');
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "view_promotion",
        ecommerce: {
            creative_name:creative_name ,
            creative_slot:creative_slot ,
            promotion_id:promotion_id ,
            promotion_name:promotion_name 
        }
    });
    $this.on('click', function () {
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
        event: "select_promotion",
        ecommerce: {
            creative_name:creative_name ,
            creative_slot:creative_slot ,
            promotion_id:promotion_id ,
            promotion_name:promotion_name 
        }
    })});

};
